// src/appsignal.ts
import Appsignal from "@appsignal/javascript"

export const appsignal = new Appsignal({
    key: "0fff024d-3be2-4c42-bd6b-8ee4efa9cc17",
})
